/**
 * Das zuletzt gemessene Rechteck des Anmeldefeldes.
 *
 * Warum ein Modulwert und kein React-Zustand: der Übergang beginnt in dem Augenblick, in dem die
 * Anmeldung aus dem Baum verschwindet und der Arbeitsplatz entsteht. Die beiden liegen in
 * verschiedenen Zweigen von `AppBootstrap`; ein gemeinsamer Zustand dafür hieße, die Verzweigung
 * umzubauen. Gebraucht wird aber nur eine Zahlenmenge, die den Wechsel überlebt.
 *
 * Fehlt sie (Sitzung ohne Anmeldung, etwa nach einem Neuladen), fällt der Übergang auf die
 * einfache Fassung zurück -- kein Morph, nur Willkommen und Aufblenden.
 */
export interface PanelRect {
  readonly left: number;
  readonly top: number;
  readonly width: number;
  readonly height: number;
}

let letztes: PanelRect | null = null;

export function merkePanelRect(rect: PanelRect): void {
  letztes = rect;
}

export function lesePanelRect(): PanelRect | null {
  return letztes;
}

export function vergissPanelRect(): void {
  letztes = null;
}
